
export class LoansRequest {
    employeeId : number;
  }
  
  export const LoansRequestDefault: LoansRequest = {
    employeeId: 0,
  }
  
  